// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_idx_FROM_total_LISTINGS = "%(idx)s ze %(total)s";
export const BZ2_ITEM_CLOSE = "Zav\u0159i inzer\u00e1t";
export const SERVER_FULL_NAME = "Modr\u00fd kon\u00edk";
export const SERVER_SLOGAN = "Modr\u00fd kon\u00edk \u2022 Skute\u010dn\u00ed lid\u00e9. Skute\u010dn\u00fd \u017eivot. Re\u00e1ln\u00e9 zku\u0161enosti.";
